/**
 * Various types of end signals involved in the lifetime of a campaign
 */
export enum CampaignEndSignal {
    /**
     * Denotes the campaign ended via the normal unmount of the campaign unit
     */
    OnUnmount = 'unmount',

    /**
     * Denotes the campaign ended via a user click
     */
    OnClick = 'click',

    /**
     * Denotes the campaign ended via a user dismiss action
     */
    OnUserDismiss = 'dismiss',

    /**
     * Denotes the campaign ended while it was not rendered at all
     */
    OnNotRender = 'notRender',
}
